// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipTwoToneSvg from "@fishx/icons-svg/es/asn/FileZipTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipTwoToneSvg
  }));
};

FileZipTwoTone.displayName = 'FileZipTwoTone';
export default React.forwardRef(FileZipTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileZipTwoTone.js
// module id = 2772
// module chunks = 0